import { defineComponent as _defineComponent } from 'vue'
import {computed, ref, ComputedRef} from 'vue';
import {Item, Collection} from './types'


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
    placeholder: null,
    noResult: { default: '' },
    disableFiltering: { type: Boolean },
    collections: null,
    showCollection: { type: Boolean, default: true },
    value: { default: '' },
    icon: { default: '$icon_search' },
    iconSize: { default: 24 }
  },
  emits: ["itemClicked", "input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "itemClicked", item: Item): void;
  (e: "input", value: string | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { placeholder: string, noResult: string, disableFiltering?: boolean, collections: Collection[], showCollection: boolean, value: string, icon: string, iconSize: number };





const searchActive = ref<boolean>(false);

const currentSearch = computed({
  get: () => props.value,
  set: (newValue) => {
    emit('input', newValue);
  }
})

const currentSearchLower = computed(() => currentSearch.value.toLowerCase());

const filteredCollections: ComputedRef<Collection[]> = computed(
  () => props.collections.flatMap( collection => {
    if (!collection.items || !collection.items.length) {
      return [];
    }

    if (!currentSearch.value || props.disableFiltering) {
      collection.items.map((item) => {
        item.namePrepend = item.name;
        item.nameHighlightedText = '';
        item.nameAppend = '';
        return item;
      });
      return [collection];
    }

    const found_items = collection.items.filter((item) => {
      const itemName = item.name.toLowerCase();
      const currentSearchLength = currentSearchLower.value.length;
      const foundTextStartIndex = itemName.indexOf(currentSearchLower.value);
      const foundTextEndIndex = foundTextStartIndex + currentSearchLength;

      if (foundTextStartIndex > -1) {
        item.namePrepend = item.name.substring(0, foundTextStartIndex);
        item.nameHighlightedText = item.name.substring(foundTextStartIndex, foundTextEndIndex);
        item.nameAppend = item.name.substring(foundTextEndIndex);
      }

      return foundTextStartIndex > -1;
    })

    if (found_items.length <= 0) {
      return [];
    }

    return [{
      ...collection,
      items: found_items
    }];
  })
);

function clickedItem(item: Item, collection: Collection) {
  currentSearch.value = ''
  collection.callback && collection.callback(item)
  emit('itemClicked', item)
}

function toggleSearchActive() {
  searchActive.value = false
}


return { __sfc: true,props, emit, searchActive, currentSearch, currentSearchLower, filteredCollections, clickedItem, toggleSearchActive }
}

})